export default __webpack_public_path__ + "media/images/check-24a138334c4a57aa5a21a9b3c8423d5b.png";